import React, { useEffect, useState } from 'react';
import classes from "./AllQuizes.module.css";
import Header from '../components/Header';
import BottomNavbar from '../components/BottomNavbar';
import { IoGridSharp } from "react-icons/io5";
import { FaSearch, FaChevronRight } from "react-icons/fa";
import { getAllQuiz } from '../http/http';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FaXmark, FaArrowLeft } from "react-icons/fa6";
import MediumLoader from '../components/Loaders/MediumLoader';
import { useTranslation } from 'react-i18next';
import { removeUserToken } from '../store/slices/userTokenSlice';
import { toast } from 'react-toastify';
import { imageBaseUrl } from '../utils/constants';

const AllQuizes = () => {
    const { userToken } = useSelector(state => state.persisted.userTokenSlice);
    const [quizes, setQuizes] = useState(null);
    const navigate = useNavigate();
    const [searching, setSearching] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [loading, setLoading] = useState(true);
    const { selectedLanguage } = useSelector(state => state.languageSlice);
    const { t } = useTranslation();
    const dispatch=useDispatch();
    // useEffect(() => {
    //     window.scrollTo(0, 0);
    //   }, []);

    const handleSearchChange = (event) => {
        setSearchText(event.target.value);
    };

    useEffect(() => {
        if (searchText?.trim()?.length > 0) {
            setSearchResults(() => {
                return quizes.filter((quiz) =>
                    quiz?.name?.toLowerCase().includes(searchText.toLowerCase())
                );
            })
        }
        else {
            setSearchResults([]);
        }
    }, [searchText]);

    const fetchAllQuizes = async () => {
        try {
            setLoading(true);
            const response = await getAllQuiz(selectedLanguage, userToken);
            // setQuizes(response?.data?.result);
            setQuizes(response?.data?.result?.filter((data) => data?.id!='36ad3452-bde4-42da-8023-b28aec87c030' && data?.id!='467b7d87-9173-4088-addd-9e3c083fff2d' && data?.id!='9c61a240-7faf-432a-a409-6fd114078030' && data?.id!='c566c0d3-47f1-41e8-bd9f-5c13ceacae8b' && data?.id!='bca4aea9-9403-4b92-ac42-408affdf3ca8' && data?.id!='430d2aaa-c95a-4a7b-a904-7dac65432af4' && data?.id!='6fe151f4-e4c1-43f3-8cf6-6d91caf04027' && data?.id!='cc2a6c39-9a54-4193-9926-d55449a04a49' && data?.id!='92857245-8aaa-41fc-9139-683292863e07' && data?.id!='d7b5d45f-b539-4b12-b554-1d746a840108'))
            setLoading(false);
        } catch (error) {
            if (error?.response?.status == 403) {
                dispatch(removeUserToken());
                toast.error(t("52"));
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.error?.error || error?.response?.error?.error || error?.response?.error || "Something Went Wrong!");
            }

        }
    }

    useEffect(() => {
        if (userToken) {
            fetchAllQuizes();
        }
        else {
            navigate("/")
        }

    }, [selectedLanguage, userToken]);

    return (
        <>
            <Header />


            <div className={`${classes.container} ${classes.no_padding}`}>
                <div className={classes.icon_container} onClick={() => navigate(-1)} >
                    <FaArrowLeft className={classes.grid_icon} />
                </div>
                {searching ?
                    <input
                        type='text'
                        className={classes.search_input}
                        placeholder={t("6")}
                        onChange={handleSearchChange}
                        value={searchText}
                        autoFocus
                    />
                    :
                    <div className={classes.heading}>
                        <p className={classes.heading_text}>{t("7")}</p>
                    </div>

                }


                <div className={classes.search_button} onClick={() => {
                    setSearchResults([]);
                    setSearching((prevValue) => !prevValue);
                    setSearchText("");
                }}>
                    {searching ?
                        <FaXmark className={classes.search_icon} />
                        :
                        <FaSearch className={classes.search_icon} />
                    }
                </div>
            </div>

            <div className={classes.container}>
                <div className={classes.quizes_list}>
                    {
                        loading ? <MediumLoader /> :
                            (searchResults?.length > 0 ? searchResults : quizes)?.map((quiz, idx) => {
                                return (
                                    <div className={classes.quiz_item} key={idx} onClick={() => navigate("/quiz-details", {
                                        state: quiz
                                    })}>
                                        <div className={classes.quiz_image}>
                                            <img className={classes.quiz_img}   src={quiz?.image ? `${imageBaseUrl}${quiz?.image}` : "/assets/images/download.png"} alt={quiz?.name} />
                                        </div>
                                        <div className={classes.quiz_description_container}>
                                            <p className={classes.quiz_name}>{quiz?.name}</p>
                                            <p className={classes.quiz_description}>{quiz?.description}</p>
                                        </div>
                                        <div className={classes.arrow_container}>
                                            <FaChevronRight className={classes.right_icon} />
                                        </div>
                                    </div>
                                )
                            })}
                </div>
            </div>
            <BottomNavbar active={1} />

        </>
    )
}

export default AllQuizes;